var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	8010: () => (loadSingletonVersion("default", "@angular/animations", false, [1,17,3,0], () => (__webpack_require__.e(4791).then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))))),
	14606: () => (loadSingletonVersion("default", "@angular/core", false, [1,17,3,0], () => (__webpack_require__.e(7580).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))))),
	5880: () => (loadSingletonVersion("default", "@angular/common", false, [1,17,3,0], () => (__webpack_require__.e(7935).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))))),
	17812: () => (loadSingletonVersion("default", "@angular/cdk/coercion", false, [1,17,3,0], () => (__webpack_require__.e(2814).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))))),
	27764: () => (loadSingletonVersion("default", "@angular/cdk/layout", false, [1,17,3,0], () => (__webpack_require__.e(5531).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))))),
	32778: () => (loadStrictSingletonVersion("default", "rxjs/operators", false, [2,7,8,0], () => (__webpack_require__.e(8219).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))))),
	37788: () => (loadSingletonVersion("default", "@angular/cdk/keycodes", false, [1,17,3,0], () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))))),
	44866: () => (loadStrictSingletonVersion("default", "rxjs", false, [2,7,8,0], () => (__webpack_require__.e(845).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))))),
	80952: () => (loadSingletonVersion("default", "@angular/cdk/platform", false, [1,17,3,0], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))))),
	98342: () => (loadSingletonVersion("default", "@angular/cdk/observers", false, [1,17,3,0], () => (__webpack_require__.e(1920).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers */ 39539))))))),
	39140: () => (loadSingletonVersion("default", "@angular/cdk/bidi", false, [1,17,3,0], () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))))),
	60244: () => (loadSingletonVersion("default", "@angular/cdk/a11y", false, [1,17,3,0], () => (__webpack_require__.e(9721).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))))),
	78522: () => (loadSingletonVersion("default", "@angular/cdk/scrolling", false, [1,17,3,0], () => (__webpack_require__.e(2356).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))))),
	74432: () => (loadSingletonVersion("default", "@angular/cdk/portal", false, [1,17,3,0], () => (__webpack_require__.e(6787).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))))),
	27198: () => (loadSingletonVersion("default", "@angular/cdk/collections", false, [1,17,3,0], () => (__webpack_require__.e(370).then(() => (() => (__webpack_require__(/*! @angular/cdk/collections */ 37989))))))),
	84164: () => (loadSingletonVersion("default", "@angular/core/primitives/signals", false, [1,17,3,0], () => (__webpack_require__.e(5689).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 85689))))))),
	34638: () => (loadSingletonVersion("default", "@angular/material/core", false, [1,17,3,0], () => (__webpack_require__.e(2265).then(() => (() => (__webpack_require__(/*! @angular/material/core */ 74646))))))),
	22190: () => (loadSingletonVersion("default", "@angular/forms", false, [1,17,3,0], () => (__webpack_require__.e(9694).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))))),
	36629: () => (loadSingletonVersion("default", "@angular/cdk", false, [1,17,3,0], () => (__webpack_require__.e(9017).then(() => (() => (__webpack_require__(/*! @angular/cdk */ 31398))))))),
	5976: () => (loadSingletonVersion("default", "@angular/material/button", false, [1,17,3,0], () => (__webpack_require__.e(6556).then(() => (() => (__webpack_require__(/*! @angular/material/button */ 84175))))))),
	36632: () => (loadSingletonVersion("default", "@angular/cdk/overlay", false, [1,17,3,0], () => (__webpack_require__.e(9189).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))))),
	42514: () => (loadSingletonVersion("default", "@angular/material/form-field", false, [1,17,3,0], () => (__webpack_require__.e(2569).then(() => (() => (__webpack_require__(/*! @angular/material/form-field */ 24950))))))),
	96230: () => (loadSingletonVersion("default", "@angular/material/input", false, [1,17,3,0], () => (__webpack_require__.e(7922).then(() => (() => (__webpack_require__(/*! @angular/material/input */ 95541))))))),
	26990: () => (loadSingletonVersion("default", "@angular/cdk/observers/private", false, [1,17,3,0], () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(/*! @angular/cdk/observers/private */ 98615))))))),
	1929: () => (loadSingletonVersion("default", "@angular/platform-browser", false, [1,17,3,0], () => (__webpack_require__.e(8055).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))))),
	46972: () => (loadSingletonVersion("default", "@angular/common/http", false, [1,17,3,0], () => (__webpack_require__.e(8824).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))))),
	10652: () => (loadSingletonVersion("default", "@angular/cdk/text-field", false, [1,17,3,0], () => (__webpack_require__.e(7559).then(() => (() => (__webpack_require__(/*! @angular/cdk/text-field */ 69940))))))),
	28198: () => (loadSingletonVersion("default", "@angular/material/tooltip", false, [1,17,3,0], () => (__webpack_require__.e(8259).then(() => (() => (__webpack_require__(/*! @angular/material/tooltip */ 80640))))))),
	58956: () => (loadSingletonVersion("default", "@angular/material/select", false, [1,17,3,0], () => (__webpack_require__.e(7556).then(() => (() => (__webpack_require__(/*! @angular/material/select */ 25175))))))),
	10858: () => (loadSingletonVersion("default", "@angular/cdk/stepper", false, [1,17,3,0], () => (__webpack_require__.e(6366).then(() => (() => (__webpack_require__(/*! @angular/cdk/stepper */ 63985))))))),
	58726: () => (loadSingletonVersion("default", "@angular/material/icon", false, [1,17,3,0], () => (__webpack_require__.e(1459).then(() => (() => (__webpack_require__(/*! @angular/material/icon */ 93840))))))),
	7432: () => (loadSingletonVersion("default", "@angular/cdk/table", false, [1,17,3,0], () => (__webpack_require__.e(7817).then(() => (() => (__webpack_require__(/*! @angular/cdk/table */ 90198))))))),
	28940: () => (loadSingletonVersion("default", "@angular/cdk/tree", false, [1,17,3,0], () => (__webpack_require__.e(333).then(() => (() => (__webpack_require__(/*! @angular/cdk/tree */ 72714))))))),
	24730: () => (loadSingletonVersion("default", "@angular/animations/browser", false, [1,17,3,0], () => (__webpack_require__.e(655).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))))),
	66656: () => (loadSingletonVersion("default", "keycloak-angular", false, [4,15,3,0], () => (__webpack_require__.e(2218).then(() => (() => (__webpack_require__(/*! keycloak-angular */ 9837)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"78": [
		7432,
		14606,
		17812,
		27198,
		32778,
		34638,
		44866
	],
	"80": [
		5880
	],
	"198": [
		5880,
		14606,
		17812,
		27198,
		32778,
		39140,
		44866,
		78522,
		80952
	],
	"316": [
		14606
	],
	"333": [
		39140
	],
	"433": [
		14606
	],
	"436": [
		5880,
		14606,
		46972
	],
	"604": [
		5880,
		8010,
		14606,
		32778,
		34638,
		37788,
		39140,
		44866,
		60244,
		74432,
		78522,
		80952,
		98342
	],
	"640": [
		5880,
		8010,
		14606,
		17812,
		32778,
		34638,
		36632,
		37788,
		39140,
		44866,
		60244,
		74432,
		78522,
		80952
	],
	"655": [
		8010
	],
	"760": [
		14606,
		27198,
		28940,
		32778,
		34638,
		44866
	],
	"1299": [
		5880
	],
	"1398": [
		14606
	],
	"1459": [
		1929,
		32778,
		34638,
		46972
	],
	"1570": [
		5880,
		14606,
		17812,
		32778,
		37788,
		39140,
		44866,
		74432,
		78522,
		80952
	],
	"1721": [
		14606,
		17812,
		34638
	],
	"1920": [
		17812
	],
	"2075": [
		5880,
		14606,
		32778,
		44866
	],
	"2102": [
		5880,
		14606,
		17812,
		27764,
		32778,
		37788,
		44866,
		80952,
		98342
	],
	"2218": [
		5880
	],
	"2243": [
		5976,
		14606,
		28198,
		34638,
		42514,
		44866,
		58956
	],
	"2265": [
		5880,
		17812,
		32778,
		36629,
		37788,
		39140,
		44866,
		60244,
		80952
	],
	"2356": [
		17812,
		27198,
		39140,
		80952
	],
	"2569": [
		5880,
		8010,
		17812,
		26990,
		32778,
		39140,
		80952,
		98342
	],
	"2691": [
		1929,
		5880,
		14606,
		32778,
		44866
	],
	"2714": [
		14606,
		27198,
		32778,
		39140,
		44866
	],
	"3036": [
		8010,
		14606
	],
	"3680": [
		5880,
		14606
	],
	"3835": [
		1929,
		5880,
		14606,
		24730
	],
	"3840": [
		1929,
		5880,
		14606,
		32778,
		34638,
		44866,
		46972
	],
	"3985": [
		14606,
		32778,
		37788,
		39140,
		44866,
		60244,
		80952
	],
	"4175": [
		14606,
		34638,
		60244,
		80952
	],
	"4241": [
		5880,
		8010,
		10858,
		14606,
		32778,
		34638,
		39140,
		44866,
		58726,
		60244,
		74432,
		80952
	],
	"4358": [
		5880,
		5976,
		8010,
		14606,
		17812,
		22190,
		32778,
		34638,
		36632,
		37788,
		39140,
		42514,
		44866,
		60244,
		74432,
		78522,
		80952,
		96230
	],
	"4428": [
		8010,
		14606,
		34638,
		37788,
		44866,
		60244
	],
	"4643": [
		14606,
		22190,
		34638
	],
	"4646": [
		5880,
		14606,
		17812,
		32778,
		36629,
		37788,
		39140,
		44866,
		60244,
		80952
	],
	"4791": [
		5880
	],
	"4950": [
		5880,
		8010,
		14606,
		17812,
		26990,
		32778,
		34638,
		39140,
		44866,
		80952,
		98342
	],
	"5175": [
		5880,
		8010,
		14606,
		22190,
		27198,
		32778,
		34638,
		36632,
		37788,
		39140,
		42514,
		44866,
		60244,
		78522
	],
	"5531": [
		17812,
		80952
	],
	"5541": [
		10652,
		14606,
		17812,
		22190,
		34638,
		42514,
		44866,
		80952
	],
	"5984": [
		14606,
		32778,
		44866,
		46972,
		66656
	],
	"6366": [
		37788
	],
	"6443": [
		5880,
		14606,
		32778,
		44866
	],
	"6556": [
		60244,
		80952
	],
	"6693": [
		14606,
		32778,
		44866
	],
	"7171": [
		5880,
		14606,
		34638,
		80952
	],
	"7172": [
		5880,
		14606
	],
	"7556": [
		5880,
		8010,
		22190,
		27198,
		32778,
		36632,
		37788,
		39140,
		60244,
		78522
	],
	"7559": [
		5880,
		32778
	],
	"7580": [
		32778,
		44866,
		84164
	],
	"7699": [
		5880,
		14606
	],
	"7817": [
		5880,
		39140,
		78522,
		80952
	],
	"7912": [
		14606,
		17812,
		32778,
		44866,
		80952
	],
	"7922": [
		10652,
		17812,
		80952
	],
	"7989": [
		14606,
		44866
	],
	"8055": [
		46972
	],
	"8259": [
		5880,
		8010,
		17812,
		32778,
		36632,
		37788,
		39140,
		60244,
		74432,
		78522,
		80952
	],
	"8473": [
		5880,
		14606,
		17812,
		32778,
		39140,
		44866,
		60244,
		78522,
		80952
	],
	"8615": [
		14606,
		32778,
		44866
	],
	"8653": [
		5880,
		8010,
		14606,
		32778,
		34638,
		36632,
		37788,
		39140,
		44866,
		60244,
		74432,
		78522,
		80952
	],
	"8753": [
		5880,
		14606,
		34638
	],
	"8824": [
		5880,
		32778,
		44866
	],
	"9168": [
		5880,
		14606
	],
	"9189": [
		17812,
		74432,
		80952
	],
	"9539": [
		14606,
		17812,
		32778,
		44866
	],
	"9694": [
		5880,
		32778,
		44866
	],
	"9721": [
		5880,
		17812,
		27764,
		32778,
		37788,
		44866,
		80952,
		98342
	],
	"9837": [
		5880,
		14606,
		32778,
		44866,
		46972
	],
	"9940": [
		5880,
		14606,
		17812,
		32778,
		44866,
		80952
	],
	"9975": [
		5880,
		14606,
		17812,
		27198,
		32778,
		39140,
		44866,
		80952
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}